<template>
  <div class="form-custom-report">

    <div class="ibox col-60">
      <div class="ibox-title">
        <span>{{ title }} Relatório</span>
      </div>

      <div class="ibox-content">
        <div class="row">
          <template v-if="customReport.id">
            <div class="col-md-8">
              <input v-model="customReport.name" class="form-control" disabled>
            </div>
          </template>

          <template v-else>
            <div class="col-md-8">
              <input v-model="customReport.name" class="form-control" placeholder="Nome do relatório">
            </div>
          </template>

          <div class="col-md-4">
            <button :disabled="customReport.schema.length === 0" @click="save()" class="btn btn-primary float-right">
              Salvar
            </button>
            <button @click="cancel()" class="btn btn-outline float-right mr-2">
              Cancelar
            </button>
          </div>
        </div>

        <hr/>
        <table id="table-custom-report">
          <thead>
            <tr>
              <th>Campo</th>
              <th>Título</th>
              <th>Formato</th>
              <th>
                <button class="btn btn-outline btn-sm nowrap" @click="addRow()">
                  <PlusIcon/>Nova linha
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in customReport.schema" :key="index">
              <td>
                <select v-model="row[0]" class="form-control">
                  <option selected="selected" value="" title="Campo em branco">-</option>
                  <option v-for="option in options" :key="`${index}-${option.key}`" :value="option.key" :title="option.name">
                    {{ option.name }}
                  </option>
                  <optgroup
                    v-if="customFieldsOptions.length > 0"
                    label="Campos personalizados">
                    <option v-for="option in customFieldsOptions" :key="`${index}-${option.key}`" :value="option.key">
                      {{ option.name }}
                    </option>
                  </optgroup>
                </select>
              </td>
              <td>
                <input v-model="row[1]" class="form-control" placeholder="Título">
              </td>
              <td>
                <select v-if="haveFormats(row[0])" v-model="row[2]" class="form-control">
                  <option v-for="format in findFormats(row[0])" :key="format.value" :value="format.value">
                    {{ format.label }}
                  </option>
                </select>

                <input v-else value="texto" disabled class="form-control">
              </td>

              <!-- Actions -->
              <td class="nowrap">
                <button class="btn btn-outline btn-sm mr-1"
                  @click="move(index - 1, index)"
                  :disabled="index === 0">
                  <ArrowUpIcon size="1x"/>
                </button>
                <button class="btn btn-outline btn-sm mr-1"
                  @click="move(index + 1, index)"
                  :disabled="(index + 1) === customReport.schema.length">
                  <ArrowDownIcon size="1x"/>
                </button>
                <button class="btn btn-outline btn-sm mr-1" @click="clone(index, row)">
                  <CopyIcon size="1x"/>
                </button>
                <button class="btn btn-outline btn-sm" @click="remove(index)">
                  <MinusIcon size="1x"/>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
  import { ArrowDownIcon, ArrowUpIcon, CopyIcon, MinusIcon, PlusIcon } from 'vue-feather-icons'
  import EntityProxy from '@/models/EntityProxy'

  const formatDescription = {
    datetime_iso: 'Data e hora (ISO)',
    datetime_european: 'Data e hora (Europeu)',
    date_iso: 'Data (ISO)',
    date_european: 'Data (Europeu)',
    time: 'Hora',
    currency: 'Moeda',
    cents: 'Centavos (Número inteiro)',
    string: 'Texto',
  }

  export default {
    created() {
      this.loadExtraData()
    },
    components: { ArrowDownIcon, ArrowUpIcon, CopyIcon, MinusIcon, PlusIcon },
    computed: {
      title() {
        return this.customReport.id ? 'Editar' : 'Novo'
      },
      options() {
        const customReportSchema = {...this.customReportSchema}
        if (this.enableBoletoLink)
          customReportSchema['boleto_link'] = { name: 'Link do boleto', type: 'string' }

        return Object.entries(customReportSchema).map(([key, value]) => ({ ...value, key }))
      },
      enableBoletoLink() {
        return this.featureFlags['cm-embarcador/boleto_link']
      },
      customFieldsOptions() {
        return this.customFields.map(c => ({ key: `custom_fields.${c.name}`, name: c.name }))
      }
    },
    data: () => ({
      customFields: [],
      featureFlags: {},
    }),
    methods: {
      addRow() {
        this.customReport.schema.push(['', ''])
      },
      cancel() {
        this.$emit('cancel')
      },
      clone(index, row) {
        this.customReport.schema.splice(index, 0, [...row])
      },
      move(to, from) {
        const toRow = this.customReport.schema[to]
        const toFrom = this.customReport.schema[from]
        this.$set(this.customReport.schema, from, toRow)
        this.$set(this.customReport.schema, to, toFrom)
      },
      remove(index) {
        this.customReport.schema.splice(index, 1)
      },
      isDatetime(field) {
        const row = this.options.find(s => s.key === field)
        const fieldType = row && row[1]
        return fieldType === 'datetime' || fieldType === 'date'
      },
      haveFormats(field) {
        const option = this.options.find(option => option.key === field)
        return option?.formats && option.formats.length > 0
      },
      findFormats(field) {
        const option = this.options.find(option => option.key === field)
        return option.formats.map(f => ({ value: f, label: formatDescription[f] }))
      },
      save() {
        this.$emit('save')
      },
      async loadExtraData() {
        const loads = ['loadCustomFields', 'loadFeatureFlags']
        for (const load of loads) {
          console.log({load})
          await this[load]()
        }
      },
      loadCustomFields() {
        const customFields = this.$ls.get('cm-embarcador/multas/custom-fields')
        if (customFields) {
          this.customFields = EntityProxy.build(customFields)
          return
        }

        return this.axios.v3.get('/custom_fields?q[resource]=cm-embarcador/multa&meta=false&per_page=100000')
          .then(response => {
            this.customFields = EntityProxy.build(response.data)
            this.$ls.set('cm-embarcador/multas/custom-fields', this.customFields, { minutes: 1 })
          })
          .catch(e => this.$notify.addError(e))
      },
      loadFeatureFlags() {
        const featureFlags = this.$ls.get('feature_flags')
        if (featureFlags) {
          this.featureFlags = featureFlags
          return
        }

        const axios = this.axios.v3
        return axios.get('feature_flags')
          .then(response => {
            this.featureFlags = response.data
            console.log('featureFlags', this.featureFlags)
            this.$ls.set('feature_flags', this.featureFlags, { minutes: 10 })
          })
          .catch(e => this.$notify.addError(e))
      }
    },
    name: 'CustomReportForm',
    props: {
      customReport: { required: true, type: Object },
      customReportSchema: { required: true, type: Object },
    }
  }
</script>

<style scoped>
#table-custom-report {
  width: 100%;
  margin-top: 1rem;
}

#table-custom-report thead th {
  padding: 0.75rem;
  border-bottom: 2px solid var(--border-color);
  background-color: var(--table-header-bg);
  color: var(--primary-text-color);
}

#table-custom-report tbody td {
  padding: 0.5rem;
  border-bottom: 1px solid var(--border-color);
  background-color: var(--table-cell-bg);
}

#table-custom-report select.form-control,
#table-custom-report input.form-control {
  background-color: var(--input-bg);
  color: var(--input-text-color);
  border: 1px solid var(--input-border);
}

#table-custom-report select.form-control:focus,
#table-custom-report input.form-control:focus {
  background-color: var(--input-bg);
  color: var(--input-text-color);
  border-color: var(--primary-color);
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(42, 107, 143, 0.25);
}

#table-custom-report select.form-control option {
  background-color: var(--input-bg);
  color: var(--input-text-color);
}

#table-custom-report select.form-control optgroup {
  background-color: var(--input-bg);
  color: var(--secondary-text-color);
  font-weight: bold;
}

[data-theme="dark"] #table-custom-report select.form-control:focus {
  box-shadow: 0 0 0 0.2rem rgba(92, 179, 230, 0.25);
}

.nowrap {
  white-space: nowrap;
}
</style>
